import { render, staticRenderFns } from "./ApmsRegToolInRecord.vue?vue&type=template&id=32d3622b&scoped=true&"
import script from "./ApmsRegToolInRecord.vue?vue&type=script&lang=js&"
export * from "./ApmsRegToolInRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3622b",
  null
  
)

export default component.exports